import React, { useState, useEffect } from 'react';
import { Box, Button, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import GetAppIcon from '@mui/icons-material/GetApp';

const InstallBanner = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if banner was dismissed before
    const bannerDismissed = localStorage.getItem('installBannerDismissed');
    if (bannerDismissed) return;

    // Check if already installed
    if (window.matchMedia('(display-mode: standalone)').matches) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      
      // Show banner after 10 seconds
      setTimeout(() => {
        setShowBanner(true);
      }, 10000);
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    
    console.log(`User response: ${outcome}`);
    setShowBanner(false);
    localStorage.setItem('installBannerDismissed', 'true');
  };

  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem('installBannerDismissed', 'true');
  };

  if (!showBanner) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#2e7d32',
        color: 'white',
        padding: '12px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: '0 -2px 10px rgba(0,0,0,0.2)',
        zIndex: 9999,
        animation: 'slideUp 0.3s ease-out'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1 }}>
        <GetAppIcon />
        <Box>
          <Typography variant="body2" fontWeight="600">
            Install Our App
          </Typography>
          <Typography variant="caption" sx={{ opacity: 0.9 }}>
            Get faster ordering & offline access
          </Typography>
        </Box>
      </Box>
      
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Button
          onClick={handleInstallClick}
          variant="contained"
          size="small"
          sx={{
            backgroundColor: 'white',
            color: '#2e7d32',
            textTransform: 'none',
            fontWeight: 600,
            '&:hover': {
              backgroundColor: '#f5f5f5'
            }
          }}
        >
          Install
        </Button>
        <IconButton
          onClick={handleDismiss}
          size="small"
          sx={{ color: 'white' }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      <style>
        {`
          @keyframes slideUp {
            from {
              transform: translateY(100%);
            }
            to {
              transform: translateY(0);
            }
          }
        `}
      </style>
    </Box>
  );
};

export default InstallBanner;
